import AtriumApi from "api";

const groupsService = {
  // Get all groups for organization
  getGroups: async (params = {}) => {
    try {
      const response = await AtriumApi.get("/v1/groups", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching groups:", error);
      throw error;
    }
  },

  // Get group by ID
  getGroupById: async (id) => {
    try {
      const response = await AtriumApi.get(`/v1/groups/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching group:", error);
      throw error;
    }
  },

  // Create new group
  createGroup: async (groupData) => {
    try {
      const response = await AtriumApi.post("/v1/groups", groupData);
      return response.data;
    } catch (error) {
      console.error("Error creating group:", error);
      throw error;
    }
  },

  // Update group
  updateGroup: async (id, groupData) => {
    try {
      const response = await AtriumApi.put(`/v1/groups/${id}`, groupData);
      return response.data;
    } catch (error) {
      console.error("Error updating group:", error);
      throw error;
    }
  },

  // Delete group
  deleteGroup: async (id) => {
    try {
      const response = await AtriumApi.delete(`/v1/groups/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting group:", error);
      throw error;
    }
  },

  // Add members to group
  addMembers: async (groupId, userIds, role = "member") => {
    try {
      const response = await AtriumApi.post(`/v1/groups/${groupId}/members`, {
        userIds,
        role,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding members:", error);
      throw error;
    }
  },

  // Remove member from group
  removeMember: async (groupId, userId) => {
    try {
      const response = await AtriumApi.delete(`/v1/groups/${groupId}/members/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error removing member:", error);
      throw error;
    }
  },

  // Get groups for a user
  getUserGroups: async (userId) => {
    try {
      const response = await AtriumApi.get(`/v1/groups/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching user groups:", error);
      throw error;
    }
  },

  // Get available group types
  getGroupTypes: async () => {
    try {
      const response = await AtriumApi.get("/v1/groups/types");
      return response.data;
    } catch (error) {
      console.error("Error fetching group types:", error);
      throw error;
    }
  },
};

export default groupsService;
